import * as React from "react";
import { MarkdownRenderer } from "@/components/feature/markdown/markdownRenderer";
import { Loader } from "@/components/ui/loader";
import { useGetBusinessReportOutcomeQuery } from "@/modules/snapshots/businessReports.api";
import { ReviewVerdictBadge } from "@/modules/snapshots/grid/reviewVerdictBadge";

interface Props {
  businessReportOutcomeId: string;
  resultId: string;
}

export const GridSidebarReviewComparison: React.FC<Props> = ({ businessReportOutcomeId, resultId }) => {
  const { data: outcomeDetails, isLoading } = useGetBusinessReportOutcomeQuery(businessReportOutcomeId);
  const result = outcomeDetails?.result.find(row => row.id === resultId);
  const review = result?.review;

  if (isLoading) return <Loader />;
  if (!result || !review?.verdict || !review.second_response) {
    return <div className="p-6 text-sm text-gray-500">No review comparison available for this response.</div>;
  }

  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
      <div className="flex flex-wrap items-center gap-2 border-b px-6 py-3">
        <ReviewVerdictBadge verdict={review.verdict} />
        {review.short_explanation && <span className="text-sm text-gray-600">{review.short_explanation}</span>}
      </div>
      <div className="grid min-h-0 flex-1 grid-cols-2 divide-x overflow-hidden">
        <div className="flex min-h-0 flex-col overflow-hidden">
          <h3 className="border-b px-6 py-2 text-sm font-semibold text-gray-700">Current response</h3>
          <div className="min-h-0 flex-1 overflow-y-auto px-6 py-3">
            <MarkdownRenderer content={result.result} evidences={[]} processCitations={false} />
          </div>
        </div>
        <div className="flex min-h-0 flex-col overflow-hidden">
          <h3 className="border-b px-6 py-2 text-sm font-semibold text-gray-700">Review response</h3>
          <div className="min-h-0 flex-1 overflow-y-auto px-6 py-3">
            <MarkdownRenderer content={review.second_response} evidences={[]} processCitations={false} />
          </div>
        </div>
      </div>
    </div>
  );
};
